import {
  faCropAlt as CropAltRegular, faAlignLeft as AlignLeftRegular, faExpand as ExpandRegular, faAngleLeft as AngleLeftRegular, faAngleUp as AngleUpRegular, faAngleDown as AngleDownRegular, faAngleRight as AngleRightRegular, faArrowLeft as ArrowLeftRegular, faArrowRight as ArrowRightRegular, faArrowToBottom as ArrowToBottomRegular, faBars as BarsRegular, faBookOpen as BookOpenRegular, faBrowser as BrowserRegular, faBullhorn as BullhornRegular, faChartNetwork as ChartNetworkRegular, faChartPie as ChartPieRegular, faChevronRight as ChevronRightRegular, faCog as CogRegular, faCommentAltLines as CommentAltLinesRegular, faCommentAltSmile as CommentAltSmileRegular, faCommentsAlt as CommentsAltRegular, faCompressAlt as CompressAltRegular, faCompressWide as CompressWide, faDatabase as DatabaseRegular, faEllipsisH as EllipsisHRegular, faEnvelopeOpenDollar as EnvelopeOpenDollarRegular, faExpandAlt as ExpandAltRegular, faExpandWide as ExpandWideRegular, faExternalLink as ExternalLinkRegular, faFileCertificate as FileCertificateRegular, faFileExclamation as FileExlamationRegular, faFileExport as FileExportRegular, faFileSignature as FileSignatureRegular, faFileUpload as FileUploadRegular, faFilter as FilterRegular, faFire as FireRegular, faGripLines as GripLinesRegular, faHome as HomeRegular, faInboxIn as InboxInRegular, faInboxOut as InboxOutRegular, faInfoCircle as InfoCircleRegular, faLink as LinkRegular, faLockAlt as LockAltRegular, faMapMarkedAlt as MapMarkedAltRegular, faMinus as MinusRegular, faPaperclip as PaperclipRegular, faPen as PenRegular, faPhone as PhoneRegular, faPlus as PlusRegular, faPrint as PrintRegular, faRedo as RedoRegular, faSearch as SearchRegular, faShareAlt as ShareAltRegular, faSignature as SignatureRegular, faStopwatch as StopwatchRegular, faStream as StreamRegular, faSuitcase as SuitcaseRegular, faTachometerFast as TachometerFastRegular, faThLarge as ThLargeRegular, faTimes as TimesRegular, faTrash as TrashRegular, faUsdCircle as UsdCircleRegular, faUserCrown as UserCrownRegular, faUsers as UsersRegular, faVideo as VideoRegular, faMapMarkerAlt as MapMarkerAltRegular, faSlidersV as VerticalSliders,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowAltCircleDown as ArrowAltCircleDownSolid, faArrowAltCircleUp as ArrowAltCircleUpSolid, faBell as BellSolid, faBuilding as BuildingSolid, faCalendarAlt as CalendarAltSolid, faCalendarWeek as CalendarWeekSolid, faCaretDown as CaretDownSolid, faCaretUp as CaretUpSolid, faCheckCircle as CheckCircleSolid, faCheck as CheckSolid, faCircle as CircleSolid, faClock as ClockSolid, faCog as CogSolid, faEnvelope as EnvelopeSolid, faExclamationTriangle as ExclamationTriangleSolid, faFile as FileSolid, faFolderOpen as FolderOpenSolid, faFolder as FolderSolid, faGlobeAmericas as GlobeAmericasSolid, faGripVertical as GripVerticalSolid, faHeart as HeartSolid, faHome as HomeSolid, faImages as ImagesSolid, faMapMarkedAlt as MapMarkedAltSolid, faMapMarkerAlt as MapMarkerAltSolid, faMapPin as MapPinSolid, faPen as PenSolid, faPlusCircle as PlusCircleSolid, faRandom as RandomSolid, faSearch as SearchSolid, faStar as StarSolid, faThLarge as ThLargeSolid, faThList as ThListSolid, faTimesCircle as TimesCircleSolid, faTrash as TrashSolid, faUnlockAlt as UnlockAltSolid, faUser as UserSolid, faVideo as VideoSolid, faDownload as DownloadSolid, faLayerGroup as LayerGroupSolid, faList, faInbox,
} from '@fortawesome/free-solid-svg-icons';
import {
  faArrowRight as ArrowRightLight, faBell as BellLight, faBuilding as BuildingLight, faChartBar as ChartBarLight, faChartPie as ChartPieLight, faCommentAltLines as CommentAltLinesLight, faComment as CommentLight, faCommentsAlt as CommentsAltLight, faEnvelopeOpenDollar as EnvelopeOpenDollarLight, faEye as EyeLight, faFileCertificate as FileCertificateLight, faFileCsv as FileCsvLight, faFilePdf as FilePdfLight, faFire as FireLight, faHeart as HeartLight, faImage as ImageLight, faInboxIn as InboxInLight, faLockAlt as LockAltLight, faMapMarkedAlt as MapMarkedAltLight, faMobile as MobileLight, faPhone as PhoneLight, faRedo as RedoLight, faSignature as SignatureLight, faStar as StarLight, faThumbsDown as ThumbsDownLight, faThumbsUp as ThumbsUpLight, faTimes as TimesLight, faUser as UserLight, faUsers as UsersLight, faVideo as VideoLight, faMap as MapLight,
} from '@fortawesome/pro-light-svg-icons';
import {
  faBell as BellRegular, faBuilding as BuildingRegular, faClipboard as ClipboardRegular, faEnvelope as EnvelopeRegular, faEye as EyeRegular, faEyeSlash as EyeSlashRegular, faFilePdf as FilePdfRegular, faFile as FileRegular, faHandshake as Handshake, faMap as MapRegular, faPaperPlane as PaperPlaneRegular, faQuestionCircle as QuestionCircleRegular, faSave as SaveRegular, faStar as StarRegular, faStickyNote as StickyNoteRegular, faThumbsDown as ThumbsDownRegular, faTimesCircle as TimesCircleRegular, faUser as UserRegular,
} from '@fortawesome/free-regular-svg-icons';
import {
  faChartNetwork as ChartNetworkSolid, faCommentAltLines as CommentAltLinesSolid, faCommentsAlt as CommentsAltSolid, faEnvelopeOpenDollar as EnvelopeOpenDollarSolid, faExternalLink as ExternalLinkSolid, faFileCertificate as FileCertificateSolid, faFileChartLine as FileChartLineSolid, faLockAlt as LockAltSolid, faUsdSquare as UsdSquareSolid, faInfoSquare as InfoSquareSolid, faTasks as TasksSolid,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faFacebookF as FacebookF, faFacebookSquare as FacebookSquare, faGoogle as Google, faLinkedin as Linkedin, faLinkedinIn as LinkedinIn, faTwitter as Twitter, faTwitterSquare as TwitterSquare,
} from '@fortawesome/free-brands-svg-icons';

const Icons = {
  AlignLeftRegular,
  CropAltRegular,
  AngleUpRegular,
  AngleDownRegular,
  AngleRightRegular,
  AngleLeftRegular,
  ArrowLeftRegular,
  ArrowRightRegular,
  ArrowToBottomRegular,
  BarsRegular,
  BookOpenRegular,
  BrowserRegular,
  BullhornRegular,
  ChartNetworkRegular,
  ChartPieRegular,
  ChevronRightRegular,
  CogRegular,
  CommentAltLinesRegular,
  CommentAltSmileRegular,
  CommentsAltRegular,
  CompressAltRegular,
  CompressWide,
  DatabaseRegular,
  EllipsisHRegular,
  ExpandRegular,
  EnvelopeOpenDollarRegular,
  ExpandAltRegular,
  ExpandWideRegular,
  ExternalLinkRegular,
  FileCertificateRegular,
  FileExlamationRegular,
  FileExportRegular,
  FileSignatureRegular,
  FileUploadRegular,
  FilterRegular,
  FireRegular,
  GripLinesRegular,
  HomeRegular,
  InboxInRegular,
  InboxOutRegular,
  InfoCircleRegular,
  InfoSquareSolid,
  LinkRegular,
  LockAltRegular,
  MapMarkedAltRegular,
  MinusRegular,
  PaperclipRegular,
  PenRegular,
  PhoneRegular,
  PlusRegular,
  PrintRegular,
  RedoRegular,
  SearchRegular,
  ShareAltRegular,
  SignatureRegular,
  StopwatchRegular,
  StreamRegular,
  SuitcaseRegular,
  TachometerFastRegular,
  ThLargeRegular,
  TimesRegular,
  TrashRegular,
  UsdCircleRegular,
  UserCrownRegular,
  UsersRegular,
  VideoRegular,
  MapMarkerAltRegular,
  ArrowAltCircleDownSolid,
  ArrowAltCircleUpSolid,
  BellSolid,
  BuildingSolid,
  CalendarAltSolid,
  CalendarWeekSolid,
  CaretDownSolid,
  CaretUpSolid,
  CheckCircleSolid,
  CheckSolid,
  CircleSolid,
  ClockSolid,
  CogSolid,
  EnvelopeSolid,
  ExclamationTriangleSolid,
  FileSolid,
  FolderOpenSolid,
  FolderSolid,
  GlobeAmericasSolid,
  GripVerticalSolid,
  HeartSolid,
  HomeSolid,
  ImagesSolid,
  MapMarkedAltSolid,
  MapMarkerAltSolid,
  MapPinSolid,
  MapLight,
  MapRegular,
  PenSolid,
  PlusCircleSolid,
  RandomSolid,
  SearchSolid,
  StarSolid,
  ThLargeSolid,
  ThListSolid,
  TimesCircleSolid,
  TrashSolid,
  UnlockAltSolid,
  UserSolid,
  VideoSolid,
  ArrowRightLight,
  BellLight,
  BuildingLight,
  ChartBarLight,
  ChartPieLight,
  CommentAltLinesLight,
  CommentLight,
  CommentsAltLight,
  EnvelopeOpenDollarLight,
  EyeLight,
  FileCertificateLight,
  FileCsvLight,
  FilePdfLight,
  FireLight,
  HeartLight,
  ImageLight,
  InboxInLight,
  LockAltLight,
  MapMarkedAltLight,
  MobileLight,
  PhoneLight,
  RedoLight,
  SignatureLight,
  StarLight,
  ThumbsUpLight,
  ThumbsDownLight,
  TimesLight,
  UserLight,
  UsersLight,
  VideoLight,
  BellRegular,
  BuildingRegular,
  ClipboardRegular,
  EnvelopeRegular,
  EyeRegular,
  EyeSlashRegular,
  FilePdfRegular,
  FileRegular,
  Handshake,
  PaperPlaneRegular,
  QuestionCircleRegular,
  SaveRegular,
  StarRegular,
  StickyNoteRegular,
  ThumbsDownRegular,
  TimesCircleRegular,
  UserRegular,
  ChartNetworkSolid,
  CommentAltLinesSolid,
  CommentsAltSolid,
  EnvelopeOpenDollarSolid,
  ExternalLinkSolid,
  FileCertificateSolid,
  FileChartLineSolid,
  LockAltSolid,
  UsdSquareSolid,
  FacebookF,
  FacebookSquare,
  Google,
  Linkedin,
  LinkedinIn,
  Twitter,
  TwitterSquare,
  VerticalSliders,
  DownloadSolid,
  TasksSolid,
  LayerGroupSolid,
  faList,
  faInbox,
};

export default Icons;
